export enum Language {
    English = 'English',
    Estonian = 'Estonian',
    Norwegian = 'Norwegian',
}
